import {
  Box,
  Button,
  Divider,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import useGetColors from 'shared/hooks/useGetColors';
import { useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import {
  CreateBotAnswerFormT, createBotAnswerResolver, getCreateBotAnswerValues,
} from 'shared/form-values/channels'
import { BotAnswerT, TemplateT } from 'shared/api/types/channels'
import BotAnswerForm from './BotAnswerForm'
import { useTranslation } from 'react-i18next'

interface Props {
  title: string;
  isOpen: boolean;
  onClose: VoidFunction;
  botAnswer: BotAnswerT;
  onSubmit: (data: CreateBotAnswerFormT) => void;
  pushOptions: TemplateT[];
  buttonText: string;
}

const BotAnswerModal = ({ title, isOpen, onClose, onSubmit, botAnswer, pushOptions, buttonText }: Props) => {
  const { t } = useTranslation();
  const { gray800, white, gray100, brand500, brand400 } = useGetColors();

  const methods = useForm<CreateBotAnswerFormT>({
    defaultValues: getCreateBotAnswerValues(botAnswer),
    resolver: createBotAnswerResolver,
    mode: "onChange"
  });
  const { trigger, getValues } = methods;

  useEffect(() => {
    trigger();
  }, []);

  useEffect(() => {
    methods.reset(getCreateBotAnswerValues(botAnswer));
  }, [botAnswer, isOpen])

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(() => onSubmit(getValues()))}>
              <BotAnswerForm pushOptions={pushOptions} />
              <Divider my="20px" />
              <Box mb="20px" display="flex" justifyContent="flex-end">
                <Button
                  color={gray800}
                  bgColor={gray100}
                  borderRadius="8px"
                  onClick={onClose}
                  w="100px"
                >
                  {t('buttons.cancel')}
                </Button>
                <Button
                  color={white}
                  bgColor={gray100}
                  borderRadius="8px"
                  backgroundColor={brand500}
                  _hover={{
                    background: brand400,
                  }}
                  ml="20px"
                  w="100px"
                  type="submit"
                >
                  {buttonText}
                </Button>
              </Box>
            </form>
          </FormProvider>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default BotAnswerModal;
